/**
 * player feature routes — owned by web-public.
 * Add child routes here (this file and everything under features/player/ belong to the owner).
 * The pathless "playerFeature" route is registered once in src/app/router.tsx (frozen).
 */
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from '../../app/root-route';

export const playerFeature = createRoute({ getParentRoute: () => rootRoute, id: 'player' });

export const playerRoute = createRoute({
  getParentRoute: () => playerFeature,
  path: '/p/$playerToken',
  component: lazyRouteComponent(() => import('./pages/PlayerPortalPage'), 'PlayerPortalPage'),
});

export const playerRouteTree = playerFeature.addChildren([playerRoute]);
